<template>
    <b-modal ref="mdlAccettazioneNRE" id="mdlAccettazioneNRE" size="xl" @shown="onShownModal"
        style="height: 100%; width: 100%" no-close-on-backdrop no-close-on-esc hide-header-close
        title="Accettazione Codice Fiscale e NRE">
        <div class="sa-ft-grid">
            <!---  <div class="sa-ft-field flex-main">
                <div class="sa-ft-icon-box">👤</div>
                <div class="sa-ft-inner-row">
                    <div class="sa-ft-inner-column flex-main">
                        <label class="sa-ft-form-label">Codice Fiscale</label>
                        <input class="sa-ft-form-input" v-model="codiceFiscale" type="text">
                    </div>
                </div>
            </div>-->
            <div class="sa-ft-field flex-main">
                <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                <div class="sa-ft-inner-row">
                    <div class="sa-ft-inner-column flex-main">
                        <label class="sa-ft-form-label">Numero Ricetta Elettronica</label>
                        <input class="sa-ft-form-input" v-model="nre" @keyup.enter="onRicercaAssistito" type="text">
                    </div>

                    <button type="button" @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                        <span>Ricerca</span>
                        <small>🔍</small>
                    </button>
                </div>
            </div>
        </div>
        <section class="sa-ft-section-container" v-if="jsonDataIntegrazione != null && isCallComplete">
            <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
                <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" title="Dati Anagrafici"
                    active>
                    <accettazione-ssn-anagrafica-component-n @changeJsonData="onChangeJsonData"
                        :initJsonData="jsonDataIntegrazione" ref="cmpAccettazioneSsnAnagraficaComponentN"
                        :isEdit="true" />
                </b-tab>
                <b-tab style="height: 500px !important; width: 100%; overflow-y: scroll;" title="Impegnativa">
                    <div v-for="(ricetta, index) in jsonDataIntegrazione.ricette" :key="index">
                        <section class="sa-ft-section-container">
                            <div class="sa-ft-form-card">
                                <div class="sa-ft-card-header">
                                    <div class="sa-ft-section-icon">🚀</div>
                                    <h3>Ricetta</h3>
                                    <div style="display: table; margin-left: auto; text-align: right;">
                                        <label class="sa-ft-label">Priorità</label>
                                        <div style="display: table; margin-left: auto; text-align: right;">
                                            <div class="sa-ft-circle-wrapper-orange">{{ ricetta.classePriorita }} </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">🏷️</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Tipologia Ricetta</label>
                                            <span class="sa-ft-value">{{ ricetta.tipologiaRicetta }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">𝄃𝄃𝄂𝄀𝄁𝄃𝄂𝄂𝄃</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">NRE</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceBar1 }}{{ ricetta.codiceBar2
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-1">
                                        <div class="sa-ft-icon-box">👤</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Codice Fiscale Assistito</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceFiscaleAssistito }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-3">
                                        <div class="sa-ft-icon-box">📅</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Data Prescrizione</label>
                                            <span class="sa-ft-value">{{ formatDateTime(ricetta.dataPrescrizione)
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">📋</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Esenzione</label>
                                            <span class="sa-ft-value">{{ ricetta.codiceEsenzione }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">📋</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Non Esente</label>
                                            <span class="sa-ft-value" v-if="ricetta.nonEsente">✅</span>
                                            <span class="sa-ft-value" v-else>❌</span>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-auto">
                                        <div class="sa-ft-icon-box">📋💰</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Esenzione Reddito</label>
                                            <span class="sa-ft-value" v-if="ricetta.esenteReddito">✅</span>
                                            <span class="sa-ft-value" v-else>❌</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-3">
                                        <div class="sa-ft-icon-box">📅</div>
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Data Prescrizione</label>
                                            <span class="sa-ft-value">{{ formatDateTime(ricetta.dataPrescrizione)
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="sa-ft-card-header" v-b-toggle="'collapse-prestazioni'">
                                    <div class="sa-ft-section-icon">🚀</div>
                                    <h3>Prestazioni</h3>
                                    <div style="display: table; margin-left: auto; text-align: right;">
                                        <span class="sa-ft-circle-wrapper"> {{ ricetta.prestazioni.length }}</span>
                                    </div>
                                    <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                        :class="{ 'is-open': isOpen }">▼</span>
                                </div>
                                <b-collapse @show="gestisciApertura()" @hide="gestisciChiusura()"
                                    :id="'collapse-prestazioni'">
                                    <div class="sa-ft-modern-cards-wrapper"
                                        v-for="(prestazione, index) of ricetta.prestazioni" :key="index">
                                        <li style="width: 100% !important; padding: 5px;">
                                            <div class="sa-ft-modern-card sa-ft-modern-card-default">
                                                <div class="sa-ft-grid">
                                                    <div class="sa-ft-field-normal flex-auto">
                                                        <div class="sa-ft-data">
                                                            <span class="sa-ft-data-value"
                                                                style="font-size: 2.0rem; line-height: 1;">⚡</span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-main">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Prestazione</label>
                                                            <span class="sa-ft-data-value">{{
                                                                prestazione.descrizionePrestazione }}</span>
                                                            <span class="sa-ft-data-value-sub cursive">{{
                                                                prestazione.codicePrestazione
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-2 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Branca</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    <span class="sa-ft-data-value">{{
                                                                        prestazione.specialization
                                                                        }}</span>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-1 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Stato</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ prestazione.statoAttuale.toUpperCase() }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-auto text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Quantita</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ prestazione.quantita }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-auto text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Tariffa</label>
                                                            <span class="sa-ft-data-value">
                                                                <span class="sa-ft-badge primary">
                                                                    {{ formatEuro(prestazione.prezzo) }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="sa-ft-field-normal flex-1 text-center">
                                                        <div class="sa-ft-data">
                                                            <label class="sa-ft-data-label">Appuntamento</label>
                                                            <span class="sa-ft-data-value">
                                                                <div class="sa-ft-value-combine-wrapper">
                                                                    <div class="sa-ft-value-combine"
                                                                        v-for="appuntamento of prestazione.appuntamenti"
                                                                        :key="appuntamento.id">
                                                                        <div class="sa-ft-value-combine-row">
                                                                            <span
                                                                                class="sa-ft-value-combine-label">I:</span>
                                                                            <span class="sa-ft-value-combine-value">
                                                                                {{
                                                                                    formattaData(appuntamento.dataRiferimento)
                                                                                }}
                                                                                {{
                                                                                    appuntamento.dalleOre
                                                                                }}</span>
                                                                        </div>
                                                                        <div class="sa-ft-value-combine-row">
                                                                            <span
                                                                                class="sa-ft-value-combine-label">F:</span>
                                                                            <span class="sa-ft-value-combine-value">
                                                                                {{
                                                                                    formattaData(appuntamento.dataRiferimento)
                                                                                }}
                                                                                {{
                                                                                    appuntamento.alleOre
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                </b-collapse>
                            </div>
                        </section>
                    </div>
                </b-tab>
            </b-tabs>
        </section>
        <template #modal-footer>
            <div class="w-100">
                <p class="float-left">Conferma per Dati Anagrafici e Prestazioni</p>
                <b-button variant="primary" size="sm" class="float-right ml-3" @click="onConfermaDatiPaziente">
                    👉 Conferma Dati Paziente
                </b-button>
                <b-button variant="primary" size="sm" class="float-right" @click="closeModalAccettazioneNre">
                    ❌ Annulla
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import toast from "../../../../template/layout/utility/sa-toast";
import AccettazioneSsnAnagraficaComponentN from "../../ssn/components/AccettazioneSsnAnagraficaComponentN.vue";
import SaccSarrMixin from "../../ssn/mixins/SaccSarrMixin";
export default {
    components: { AccettazioneSsnAnagraficaComponentN },
    mixins: [SaccSarrMixin],
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            nre: null,
            presidio: {},
            openPrestazioni: false,
            codiceStruttura: null,
            isOpen: false,
            codiceFiscale: "",
            jsonData: {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
                //details: [{ "id": 77579178, "service": { "id": "89.7A.3_0_N24", "code": "89.7A.3_0", "name": "PRIMA VISITA CARDIOLOGICA. INCLUSO: ECG (89.52)", "startDate": "2024-12-30T00:00:00.000+00:00", "endDate": "2999-12-31T00:00:00.000+00:00", "weight": 1, "groupId": "PA" }, "specialization": { "id": "24-08", "name": "CARDIOLOGIA - 24" }, "requiresSpecificConsent": false, "price": 33.6, "variablePrice": "N", "quantity": 1, "booking": { "id": "26075826", "code": "11711200000126", "startTime": "1900-01-01T11:40:00Z", "endTime": "1900-01-01T12:00:00Z", "diary": { "id": "16929821" }, "registrationUser": { "id": "1002323", "name": "BRNFPP97B07H501V" } }, "executionUnit": { "id": "UE-FRO-00016668", "name": "[CASRAFCARDGAMB] - CARDIOLOGIA DOTT. GAMBARDELLA" }, "scheduledDatetime": "2026-04-28T10:40:00Z", "executionDatetime": "2026-04-28T10:40:00Z", "status": { "id": "ACT", "name": "Accettata" }, "enable": "Y", "statusReason": { "id": "3", "name": "Indicazione del medico erogatore" }, "phoneNumber": "3123123123", "site": { "id": "SIT-FRO-00000951", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA", "address": "VIA GAETANO DI BIASIO, 1" }, "hospital": { "id": "HOS-FRO-00001088", "name": "SAN RAFFAELE CASSINO CASA DI CURA PRIVATA ACCREDITATA" }, "authority": { "id": "STR0000375", "name": "ASL FROSINONE", "code": "120112" } }]
            },
            isCallComplete: false,
            jsonDataIntegrazione: null,

        }
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio) {
            this.presidio = JSON.parse(tmpPresidio);
            this.codiceStruttura = this.presidio.codiceStruttura;
        }
    },
    methods: {
        open() {
            this.$refs.mdlAccettazioneNRE.show();
        },
        close() {
            this.$refs.mdlAccettazioneNRE.hide();
        },
        togglePrestazioni() {
            this.openPrestazioni = !this.openPrestazioni;
        },
        onConfermaDatiPaziente() {
            this.openShowModalLoading()

            console.log(this.jsonDataIntegrazione);
            delete this.jsonDataIntegrazione.integrationAccettazione;
            delete this.jsonDataIntegrazione.accettazionePrestazioni;
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn";
            axios.post(link, this.jsonDataIntegrazione).then((response) => {
                let idPaziente = response.data.data.id;
                this.$router.push("/frosinone/accettazione/" + idPaziente);
                this.$emit("afterSaved", response)
                this.closeShowModalLoading();
            }).catch((err) => {
                this.closeShowModalLoading();
                toast.error(err.response.data.messaggio)
            });

        },
        onInputTabs(i) {
            console.log(i);
        }, formattaData(dataString) {
            if (!dataString) return '';
            // Separa l'anno, il mese e il giorno [yyyy, mm, dd]
            const parti = dataString.split('-');
            // Li riunisce al contrario: dd/mm/yyyy
            return `${parti[2]}/${parti[1]}/${parti[0]}`;
        },
        onChangeJsonData(json) {
            this.jsonDataIntegrazione = JSON.parse(JSON.stringify(json));
            this.jsonDataIntegrazione.accettazioneAnagrafica = this.jsonDataIntegrazione.accettazione.accettazioneAnagrafica;
        },
        onRicercaAssistito() {
            if (this.nre == null || this.nre.trim() == "") {
                toast.error("Inserire NRE valido !")
                this.closeShowModalLoading();
                return;
            }
            this.openShowModalLoading();
            this.isCallComplete = false;
            let filter = {
                nre: this.nre
            }
            let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.codiceStruttura;
            axios.get(link, { params: filter }).then((response) => {
                console.log(response);
                this.jsonDataIntegrazione = response.data.data;
                this.isCallComplete = true;
                this.closeShowModalLoading();
            }).catch((err) => {
                toast.error(err.response.data.messaggio)
                this.isCallComplete = false;
                this.closeShowModalLoading();
            });
        },
        gestisciApertura(item, index) {
            if (item) {
                this.$set(item, 'isOpen', true);
                console.log(`Gruppo ${index} aperto`);
            }
            this.isOpen = true;
        },
        gestisciChiusura(item, index) {
            if (item) {
                this.$set(item, 'isOpen', false);
                console.log(`Gruppo ${index} chiuso`);
            }
            this.isOpen = false;
        },
        formatEuro(value) {
            if (value === null || value === undefined || isNaN(value)) return '€ 0,00';

            return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR'
            }).format(value);
        },
        // onRicercaAssistitoSuccess(response) {
        //     this.jsonData = response.data.data == null ? response.data.data : response.data.data.content[0];
        //     if (this.jsonData == null) {
        //         toast.warning(`Non è stato possibile recuperare impegnativa nre: ${this.nre}`, "Ricerca Fallita")
        //     }
        //     this.isCallComplete = true;
        //     this.closeShowModalLoading();
        // },
        // onRicercaAssistitoError(error) {
        //     console.log(error);
        //     this.isCallComplete = false;
        //     this.closeShowModalLoading();
        // },
        onShownModal() {
            this.resetAll();
        },
        closeModalAccettazioneNre() {
            this.resetAll();
            this.close();

        },
        getOra(date) {
            return moment(date).format("HH:mm");
        },
        getFormatDate(date) {
            return moment(date).format("DD/mm/yyyy");
        },
        resetAll() {
            this.isCallComplete = false;
            this.nre = null;
            this.isOpen = false;
            this.jsonDataIntegrazione = null;
            // this.resetJsonData();
        },
        resetJsonData() {
            this.jsonData = {
                patient: {
                    code: null,
                    name: null,
                },
                details: []
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.cursive {
    font-family: cursive !important;
}

.sa-ft-arrow-icon {
    display: inline-block;
    transition: transform 0.3s ease;
    font-size: 0.8rem;
    /* Regola la dimensione a piacimento */
    color: #6c757d;
    /* Colore grigio neutro, personalizzabile */
}

/* Quando il pannello è aperto, ruota la freccia verso l'alto */
.sa-ft-arrow-icon.is-open {
    transform: rotate(180deg);
}

.sa-ft-circle-wrapper {
    /* Dimensioni e Forma */
    width: 30px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;

    /* Centratura del numero */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Estetica */
    background-color: #007bff21;
    color: rgba(0, 47, 255, 0.712);
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1.2rem;

    /* Opzionale: bordino o ombra */
    border: 2px solid #0056b3;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-circle-wrapper-orange {
    /* Dimensioni e Forma */
    width: 30px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;

    /* Centratura del numero */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Estetica */
    background-color: #ff660021;
    color: rgba(233, 71, 22, 0.801);
    font-family: sans-serif;
    font-weight: bold;
    font-size: 1.2rem;

    /* Opzionale: bordino o ombra */
    border: 2px solid #b34800;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>